
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LogoManagement } from '@/components/admin/logo/LogoManagement';
import { AiPropSettingsManagement } from '@/components/admin/ai-prop/AiPropSettingsManagement';
import { CTraderTokenManagement } from '@/components/admin/ctrader/CTraderTokenManagement';
import { MarketAnalysisSettingsManagement } from '@/components/admin/market-analysis/MarketAnalysisSettingsManagement';
import { EmailBrandingManagement } from '@/components/admin/email/EmailBrandingManagement';
import { Settings, Image, ExternalLink, Database, BarChart3, Mail } from 'lucide-react';

const AppSettingsPage = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Settings className="h-8 w-8" />
          App Settings
        </h1>
        <p className="text-muted-foreground mt-2">
          Manage global application settings and configurations
        </p>
      </div>

      <Tabs defaultValue="logo" className="space-y-6">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="logo" className="flex items-center gap-2">
            <Image className="h-4 w-4" />
            Logo Management
          </TabsTrigger>
          <TabsTrigger value="email-branding" className="flex items-center gap-2">
            <Mail className="h-4 w-4" />
            Email Branding
          </TabsTrigger>
          <TabsTrigger value="ai-prop" className="flex items-center gap-2">
            <ExternalLink className="h-4 w-4" />
            AI Prop Settings
          </TabsTrigger>
          <TabsTrigger value="ctrader" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            cTrader Management
          </TabsTrigger>
          <TabsTrigger value="market-analysis" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Market Analysis
          </TabsTrigger>
        </TabsList>

        <TabsContent value="logo">
          <LogoManagement />
        </TabsContent>

        <TabsContent value="email-branding">
          <EmailBrandingManagement />
        </TabsContent>

        <TabsContent value="ai-prop">
          <AiPropSettingsManagement />
        </TabsContent>

        <TabsContent value="ctrader">
          <CTraderTokenManagement />
        </TabsContent>

        <TabsContent value="market-analysis">
          <MarketAnalysisSettingsManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AppSettingsPage;
